import List from './OrderList';
import Add from './OrderAdd';
import View from './OrderView';

const $t = str => str;

const routes = [
	{
		path: '/orders',
		name: 'orders',
		component: { template: '<router-view/>' },
		children: [
			{
				name: 'orders.list',
				path: 'list',
				component: List
			},
			{
				title: $t('Create new Order'),
				name: 'orders.add',
				path: 'add',
				component: Add
			},
			{
				title: $t('View Order'),
				name: 'orders.view',
				path: 'view/:id',
				component: View
			}
		]
	}
];

export default routes;
